/**
 * Non-prod environment cue (dev/stage only). Two pieces:
 *   <EnvTopStrip /> — a 3px colored bar pinned to the very top edge, above the
 *     sticky top bar (z-40). Overlays without shifting layout.
 *   <EnvPill />     — a small uppercase pill for the top bar, next to the
 *     workspace switcher.
 * Both render nothing in prod/local — see `currentEnvMeta()` in lib/appEnv.
 */
import { APP_ENV, currentEnvMeta, versionLabel } from '../lib/appEnv';

export function EnvTopStrip() {
  const meta = currentEnvMeta();
  if (!meta) return null;
  return (
    <div
      aria-hidden
      className={`fixed inset-x-0 top-0 z-[60] h-[3px] pointer-events-none ${meta.strip}`}
    />
  );
}

export function EnvPill() {
  const meta = currentEnvMeta();
  if (!meta) return null;
  return (
    <span
      title={`${APP_ENV} · ${versionLabel()}`}
      aria-label={`Environment: ${meta.label}, version ${versionLabel()}`}
      className={`shrink-0 rounded-token px-1.5 py-0.5 font-sans text-[10px] font-semibold uppercase tracking-[0.16em] ${meta.pill}`}
    >
      {meta.label}
    </span>
  );
}
